/**
 * Слова «быстрой оплаты» (решение владельца 24.10.2026, RP-SALE-FAST шаг 9). Отдельный файл без зависимостей: их читают и срез попыток
 * оплаты, и селекторы, и listeners, и панель «Чек».
 */

/** Причина откладывания в журнале сеанса: понятно, что продажу отложила не рука кассира, а режим кассы. */
export const FAST_HAND_OFF_REASON = 'Быстрая оплата: чек печатается в фоне'

/** Окно оплаты после ухода в фон: что произошло и что делать дальше. */
export const FAST_HAND_OFF_DONE_TEXT = 'Чек печатается — ход виден справа. Можно набирать следующую продажу.'

/** Оплата нажата, пока чек предыдущей продажи печатается: окно ждёт его конца (этап подготовки). */
export const PAY_WAITING_RECEIPT_TEXT = 'Ждём, пока допечатается чек предыдущей продажи. Оплата начнётся сама, как только он будет готов.'

/** Строка рядом с кнопками оплаты, пока чек предыдущей продажи печатается. */
export const RECEIPT_AHEAD_STATUS_TEXT = 'Печатается чек предыдущей продажи. Корзину можно набирать; оплата начнётся, как только чек будет готов.'

